import React, { useCallback, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import URL from "../../../../constant/URL";
import http from "../../../../http/http";
import Header from "./Header";
import lottie from "lottie-web";
import TabLearning from "./TabLearning";
import TabComplete from "./TabComplete";
import LevelComplete from "./LevelComplete";
import useLearningData from "../../../../hooks/useLearningData";
import useLoading from "../../../../hooks/useLoading";
import useSound from "../../../../hooks/useSound";
import A from "../../../common/A";
import { useLearningHistory, useUserInfo } from "../../../../hooks";
import { mathpidLogAPICall } from "../../../../redux/logData";
import clsx from "clsx";
import { TYPE } from "../../../../constant";
import useAmplitude from "../../../../hooks/useAmplitude";

const List = withRouter((props) => {
  const { t } = useTranslation();
  const { info } = useUserInfo();
  const logDispatch = useDispatch();
  const { setAmplitudeLog } = useAmplitude();
  const { learningHistoryInfo } = useLearningHistory();
  const { learningData, setLearningData } = useLearningData();
  const { setLoading, clearLoading } = useLoading();
  const { setSound, playSound, clearSound } = useSound();
  const [nextLevelCode, setLevelCode] = React.useState();
  const [list, setList] = React.useState([]);
  const [level, setLevel] = React.useState('');
  const [levelNm, setLevelNm] = React.useState('');
  const [levelResult, setLevelResult] = React.useState({});
  const [levelFlag, setLevelFlag] = React.useState(false); //탭1의 리스트페이지 or 풍선페이지 선택값
  const [resultInfo, setResultInfo] = React.useState({});
  const [statusClass, setStatusClass] = React.useState("");
  const [statusPath, setStatusPath] = React.useState("");
  const [statusFlag, setStatusFlag] = React.useState(false);
  const [tab1, setTab1] = React.useState('tabCont course_list active result'); //탭1선택시 리스트 or 풍선페이지변경
  const [tab1Fire, setTab1Fire] = React.useState('fire'); //불꽃로티값
  const [tab1FireFlag, setTab1Flag] = React.useState(true); //불꽃로티값
  const [tab1Button, setTab1Button] = React.useState('active');
  const [tab2, setTab2] = React.useState('tabCont course_list list2');
  const [tab2Button, setTab2Button] = React.useState('ani_zoom');
  const [headerClass, setHeaderClass] = React.useState("header_gray_bg");
  const [msgFlag, setMsgFlag] = React.useState(false);
  const [noMsgFlag, setNoMsgFlag] = React.useState(false);
  const [changerHeader, setChangerHeader] = React.useState('layout-def with_header tab-wrap js_change_header');

  useEffect(() => {

    let logdata = null
    if (tab1Button.indexOf('active') > -1) {
      logdata = {
        verbId: 'accessed',
        objectId: 'screen',
        screenVersion: 'screenCode',
        screenCode: 'scr_0001_0000',
      }

    } else if (tab2Button.indexOf('active') > -1) {
      logdata = {
        verbId: 'accessed',
        objectId: 'screen',
        screenVersion: 'screenCode',
        screenCode: 'scr_0001_0001',
      }
    }
    if (!logdata) return;
    logDispatch(mathpidLogAPICall(logdata));

  }, [tab1Button, tab2Button]);

  const tabClassChange = useCallback((tab, result) => {
    //학습중과 완료탭눌렀을떄의 클래스 변경
    if (tab === 'tab1') {
      clearLoading();
      props.history.replace(`${URL.COURSE_LEARNING.LIST}/tab1`);
      if (result === null || Object.keys(result).length === 0) {
        setTab1('tabCont course_list active result');
      } else {
        completeLevelClassChange();
      }
      setTab1Button('active');
      setTab2('tabCont course_list list2');
      setTab2Button('ani_zoom');
      setLearningData({ answeringQuestionsComplete: false });
    } else {
      clearLoading();
      props.history.replace(`${URL.COURSE_LEARNING.LIST}/tab2`);
      setLearningData({ resultFoldingFlag: false });
      setMsgFlag(false);
      setHeaderClass('header_gray_bg');
      setChangerHeader('layout-def with_header tab-wrap js_change_header');

      setTab1('tabCont course_list');
      setTab1Button('');
      setTab2('tabCont course_list active list2');
      setTab2Button('ani_zoom active')
    }
  }, [list]);

  const completeLevelClassChange = () => {
    // setLoading({ isShowSpinner:true, spinnerType:'2' }); //풍선페이지에서 스피너 불러올시 깜빡거림
    setTab1Flag(false); //불꽃로티값
    setTab1Fire('fire no_icon'); //불꽃로티값
    setTab1('tabCont active lev_done'); //풍선표시변경
    setLevelFlag(true);
  };

  const messageHeader = (msg) => {

    //ai메세지가 1줄일때와 2줄일때의 클래스변경
    let lineCheck = msg.split('<br/>');
    let head_mess = '';

    if (lineCheck.length === 1) {
      head_mess = TYPE.CHANNEL.GLOBAL01 !== info.channelCode ? 'head_mess1' : ''
      setHeaderClass('header_gray_bg mess1');
    } else {
      head_mess = TYPE.CHANNEL.GLOBAL01 !== info.channelCode ? 'head_mess2' : ''
      setHeaderClass('header_gray_bg mess2');
    }
    setChangerHeader(`layout-def with_header tab-wrap js_change_header ${head_mess}`);
    // setHeaderClass('');
    // setChangerHeader('layout-def with_header tab-wrap js_change_header');
  };

  const aiMessage = () => {
    let changeHtml = document.getElementById('aiMsg');
    if (changeHtml && list?.aiMsge) {
      changeHtml.innerHTML = list.aiMsge;
      setTimeout(() => {
        setMsgFlag(false);
        setHeaderClass("header_gray_bg");
        setChangerHeader('layout-def with_header tab-wrap js_change_header');
      }, 6000);
    }
  };

  const getLevel = (lvlCd, dspOdr) => {
    setLevel(lvlCd);
    setLevelNm(dspOdr);
  };

  const getLevelResult = () => {
    setLearningData({ prevPage: '' });
    //1.현재레벨의 결과값을 불러옴
    if (learningHistoryInfo.isCompleteAIDiagnosis === 'N'
      || learningHistoryInfo.isCheckAIDiagnosisResult === 'N'
    ) {
      props.history.replace({ pathname: URL.SELECT_LEARNING });
      return;
    }
    if (level) {
      http.request({
        url: `${URL.API.LEARNING.COURSE}/level/result/channel/${info.channelCode}/language/KO/member/${info.learnerId}/level/${level}`,
        success: (res) => {
          setLevelResult(res);
          setLearningData({ nextLevel: res?.nextLvlDspOdr });
          setLevelCode(res?.nextLvlCd);
          if (res === null) {
            //2-1.레별이 완료전이면 null
            getList();
          } else {
            //2-2.레벨이 완료면 res
            if (info.channelCode === TYPE.CHANNEL.GLOBAL01) getResumeLeanInfo();
            
            
            getCompleteInfo([]);
            if (learningData.answeringQuestionsComplete) {
            } else {
              // setTab1Flag(false); //불꽃로티값
              // setTab1Fire('fire no_icon'); //불꽃로티값
              // setTab1('tabCont active lev_done'); //풍선표시변경
              // setLevelFlag(true); //레벨완료페이지 렌더
              if (props.id === 'tab2') {
                closeLoading();
                tabClassChange('tab2', res);
              } else {
                closeLoading();
                // tabClassChange('tab1', res);
              }
            }
          }
        }
      });
    }
  };

  const getResumeLeanInfo = () => {
    http.request({
      url: `${URL.API.LEARNING.RESUME}/language/KO/member/${info.learnerId}`,
      success: (res) => {
        closeLoading();
        let list = res;
        if(list?.resumeLeanInfo) {
          // 이어하기 학습 정보 저장
          setLearningData({ resumeLeanInfo : list?.resumeLeanInfo });
        }
      }
    });
    
  }

  const getList = () => {

    http.request({
      url: `${URL.API.LEARNING.COURSE}/channel/${info.channelCode}/language/KO/member/${info.learnerId}`,
      success: (res) => {
        closeLoading();
        //3.리스트 결과값 조회
        let list = res;

        if (learningData.answeringQuestionsComplete && props.id !== 'tab2') {
          // 4.학습종료후 결과페이지에서 바로 넘어왔을시 애니메이션 작동해야함
          getCompleteInfo(list);
          return;
        }

        if (list.aiMsge) {
          setMsgFlag(true);
          setNoMsgFlag(false);
          messageHeader(list.aiMsge);
        } else {
          setMsgFlag(false);
          setNoMsgFlag(true);
        }
        setList(list);
        
        if(list?.resumeLeanInfo) {
          // 이어하기 학습 정보 저장
          setLearningData({ resumeLeanInfo : list?.resumeLeanInfo });
        }

        const found = list?.lrnCousList.find(element => element.resumeYn === 'Y');
        if(found) tabClassChange('tab1', null);
        
        if (props.id === 'tab2') {
          tabClassChange('tab2', null);
        }
      }
    });
  };

  const getCompleteInfo = (stgList) => {
    //3.결과페이지에서 바로 넘어올시만 애니메이션 작동
    http.request({
      //개별완료정보조회
      url: `${URL.API.LEARNING.COURSE}/end/channel/${info.channelCode}/language/KO/member/${info.learnerId}/stage/${learningData.stgCd}`,
      success: (res) => {
        closeLoading();
        if (res.lrnPrgsStsCd) {
          if (res.lrnPrgsStsCd === "LPSC01") {
            setSound({ src: `${process.env.PUBLIC_URL}/static/audio/lc_03_02_fail.ogg` });
            playSound();
            setStatusClass("anifull-wrap bg-effort");
            setStatusPath(`${process.env.PUBLIC_URL}/static/json/img_lc_03_02_01.json`);
          } else {
            setSound({ src: `${process.env.PUBLIC_URL}/static/audio/lc_03_02_complete.ogg` });
            playSound();
            if (res.lrnPrgsStsCd === "LPSC02") {
              setStatusClass("anifull-wrap bg-def");
              setStatusPath(`${process.env.PUBLIC_URL}/static/json/img_lc_03_02_02.json`);
            } else if (res.lrnPrgsStsCd === "LPSC03") {
              setStatusClass("anifull-wrap bg-enough");
              setStatusPath(`${process.env.PUBLIC_URL}/static/json/img_lc_03_02_03.json`);
            } else if (res.lrnPrgsStsCd === "LPSC04") {
              setStatusClass("anifull-wrap bg-nice");
              setStatusPath(`${process.env.PUBLIC_URL}/static/json/img_lc_03_02_04.json`);
            }
          }

          setStatusFlag(true);

          setTimeout(() => {
            clearSound();
            setStatusFlag(false);
            setResultInfo(res);

            if (stgList?.aiMsge) {
              setMsgFlag(true);
              setNoMsgFlag(false);
              messageHeader(stgList?.aiMsge);
            } else {
              setMsgFlag(false);
              setNoMsgFlag(true);
            }
            setList(stgList);
            if (props.id === 'tab2') {
              tabClassChange('tab2', levelResult);
            } else {
              //levelResult가 값이 있으면 레벨완료로 풍선에니메이션 보여줌
              tabClassChange('tab1', levelResult);
            }
          }, 2000);
          return;
        }
        setResultInfo(res);

        if (list?.aiMsge) {
          setMsgFlag(true);
          setNoMsgFlag(false);
          messageHeader(list.aiMsge);
        } else {
          setMsgFlag(false);
          setNoMsgFlag(true);
        }

        setList(stgList);
        tabClassChange('tab1', levelResult);
      }
    });
  };

  const renderStatusAnimation = () => {

    let path = statusPath;

    let data = {
      container: document.getElementById('status'),
      path,
      renderer: 'svg',
      loop: false,
      autoplay: true
    };
    lottie.loadAnimation(data);
  };

  const renderHeaderAnimation = () => {
    let id = '#no_messege';
    let path = `${process.env.PUBLIC_URL}/static/json/ai_lc_03_02_01.json`;

    if (list.aiMsge && msgFlag) {
      id = '#with_messege';
      path = `${process.env.PUBLIC_URL}/static/json/ai_lc_03_02_02.json`;
    }

    let data = {
      container: document.querySelector(id),
      path,
      renderer: 'svg',
      loop: true,
      autoplay: true
    };

    lottie.loadAnimation(data);
  };

  const renderFireAnimation = () => {
    let data = {
      container: document.querySelector('#ani_fire'),
      path: `${process.env.PUBLIC_URL}/static/json/img_lc_03_fire.json`,
      renderer: 'svg',
      loop: true,
      autoplay: true
    };
    lottie.loadAnimation(data);
  };

  const renderStatus = () => {
    return (
      <div className={statusClass}>
        <div className="anifull-ani">
          <div className="anim-wrap" id="status"></div>
        </div>
      </div>
    )
  };

  const startLoading = () => {
    setLoading({ isShowSpinner: true, spinnerType: '2' });
  };

  const closeLoading = () => {
    clearLoading();
  };

  React.useEffect(() => {
    if (learningHistoryInfo.isCompleteAIDiagnosis === 'N') {
      props.history.push(URL.SELECT_LEARNING);
    }
  }, [learningHistoryInfo]);

  React.useEffect(() => {
    startLoading();
    setAmplitudeLog({ eventCategory: 'app_usage', eventName: '코스학습메인 조회', isHackleSend: true, });
  }, []);
  React.useEffect(getLevelResult, [level]);
  React.useEffect(renderStatusAnimation, [statusFlag]);
  React.useEffect(renderHeaderAnimation, [list, msgFlag, noMsgFlag]);
  React.useEffect(renderFireAnimation, [list, msgFlag, noMsgFlag]);
  React.useEffect(aiMessage, [list, msgFlag, statusFlag]);

  const TabBtn = (
    <div className="tab_fix_wrap">
      <ul className="course_tab tablist cls">
        <li className={tab1Fire}>
          <A className={tab1Button} onClick={(e) => {
            e.stopPropagation();
            tabClassChange('tab1', levelResult);
          }
          }>
            <span>
              {tab1FireFlag && <div className="anim-wrap" id="ani_fire"></div>}
            </span>
            {t("LC_03_02.msg003")}
          </A>
        </li>
        <li><A className={tab2Button} onClick={(e) => {
          e.stopPropagation();
          tabClassChange('tab2', levelResult)
        }}>{t("LC_03_02.msg004")}</A></li>
      </ul>
    </div>
  )

  return (
    <>
      <Header headerClass={headerClass} url={URL.COURSE_LEARNING.LIST} getLevel={getLevel} />
      <div className={clsx(
        changerHeader,
        info.className,
      )}>
        {statusFlag && renderStatus()}
        <div className="header">
          {
            TYPE.CHANNEL.GLOBAL01 === info.channelCode
              ? (
                <>
                  <div className="character_wrap js_scroll_head">
                    {
                      msgFlag && (
                        <p className="txt" id="aiMsg"></p>
                      )
                    }
                    <div className="img_wrap">
                      <div className="cont">
                        {
                          msgFlag 
                            ? (<img style={{ width: '100%' }}src={`${process.env.PUBLIC_URL}/static/images/common/cha_lc_aimessage_th_02.svg`} alt="" />)
                            : (<img height="92" style={{width: '100%'}} src={`${process.env.PUBLIC_URL}/static/images/common/cha_lc_aimessage_th_03@1.5x.png`} alt="" />)
                        }
                      </div>
                    </div>
                  </div>
                  {TabBtn}
                </>
              )
              : (
                <div className="inner">
                  <div className="messege_wrap">
                    {msgFlag && <div className="messege"><b id="aiMsg"></b></div>}
                  </div>
                  <div className="head_img_wrap">
                    {msgFlag && <div className="anim-wrap with_messege" id="with_messege"></div>}
                    {!msgFlag && <div className="anim-wrap no_messege" id="no_messege"></div>}
                  </div>
                  {TabBtn}
                </div>
              )
          }
        </div>

        <div className="container">
          <div className="inner">
            <div className="course_tab_wrap">
              <div className={tab1} id="tabCont1">
                {levelFlag && <LevelComplete result={levelResult} level={level} levelNm={levelNm} nextLevelCode={nextLevelCode} />}
                <TabLearning list={list} resultInfo={resultInfo} levelResult={levelResult} completeLevelClassChange={completeLevelClassChange} />
              </div>
              <div className={tab2} id="tabCont2">
                <TabComplete onChangeTab={tabClassChange}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

});

export default List;
